import { ACTION_STATUS } from "constants/actions";

const checkIfPerformedWithSuggested = (values) => {
  const suggestedActionExists = Boolean(values?.suggestedActionId);

  const actionWasNotInitiallyPerformed =
    values.status === ACTION_STATUS.performed &&
    values.initialStatus !== ACTION_STATUS.performed;

  return suggestedActionExists || actionWasNotInitiallyPerformed;
};

export default checkIfPerformedWithSuggested;
